interface ITrackingCodes {
  FOR_HOME: string;
  FOR_BUSINESS: string;
  ABOUT_ORIGIN: string;
  BLOG: string;
  SEE_OUR_PLANS: string;
  HELP: string;
  SEARCH: string;
  LOGIN: string;
  TOGGLE_NAVIGATION: string;
  TOGGLE_MENU: string;
  PERSONALISED_CONTENT_PROSPECTS: string;
  PERSONALISED_CONTENT_MOVING: string;
}

export const TRACKING_CODES: ITrackingCodes = {
  FOR_HOME: "fly:for home:l0:for home",
  FOR_BUSINESS: "fly:for home:l0:for business",
  ABOUT_ORIGIN: "fly:for home:l0:about origin",
  BLOG: "fly:for home:l0:blog",
  SEE_OUR_PLANS: "fly:for home:l0:see our plans",
  HELP: "fly:for home:l0:help",
  SEARCH: "fly:for home:l0:search",
  LOGIN: "fly:for home:l0:login",
  TOGGLE_NAVIGATION: "fly:for home:l0:toggle navigation",
  TOGGLE_MENU: "for-home:alnk:toggle menu",
  PERSONALISED_CONTENT_PROSPECTS:
    "mobile-navigation:personalised-content-prospects",
  PERSONALISED_CONTENT_MOVING: "mobile-navigation:personalised-content-moving"
};
